require('es5-shim');
require('es5-shim/es5-sham');
require('console-polyfill');

require('../lib-sass/health.scss');
require('../sass/home.scss');
var Swiper = require('swiper');
var $ = require('jquery');

var mySwiper = new Swiper('.swiper-container', {
  //   direction: 'vertical', // 垂直切换选项
  loop: true, // 循环模式选项
  spaceBetween: 80,
  centeredSlides: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  },
  // 如果需要分页器
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + '</span>';
    }
  }

  // 如果需要前进后退按钮
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev',
  //   },

  // 如果需要滚动条
  //   scrollbar: {
  //     el: '.swiper-scrollbar',
  //   },
});

function requestForMTOP(params, config) {
  var api = config.api || '',
      v = config.v || '1.0',
      ecode = config.ecode || 1;

  lib.mtop.config.prefix = 'api2';
  if (window.location.href.indexOf('www.mashangfangxin.com:6001') > -1 || window.location.href.indexOf('pre.mashangfangxin.com') > -1) {
    lib.mtop.config.prefix = 'pre-api2';
  }
  lib.mtop.config.mainDomain = 'mashangfangxin.com'; // mtop的主域
  lib.mtop.config.subDomain = ['waptest', 'wapa', ''][2]; // 线上

  return lib.mtop.H5Request({
    AntiCreep: true, // 防爬
    api: api,
    v: v,
    data: params,
    ecode: ecode
  });
}

function validate(checkCode) {
  return $.ajax({
    url: '/api/verificationCheckCode',
    type: 'POST',
    dataType: 'JSON',
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    data: {
      checkCode: checkCode
    }
  });
}

function code() {
  var box = $('.scan-code .code');
  var code = box.find('.figure');

  code.find('img.first').mouseenter(function (e) {
    e.stopPropagation();
    $(this).css('display', 'none').siblings('img').css('display', 'block');
  });

  code.find('img.second').mouseleave(function (e) {
    e.stopPropagation();
    $(this).hide().siblings('img').show();
  });

  //刷新验证码
  // $('#captchaImg').on('click', function(e) {
  //   $(this).attr('src', '/api/captcha?r=' + Math.random());
  // });

  $('.t-code').keyup(function (e) {
    $('#scanCode').css({ border: 'none' });
    $('#scanCodeError').css({ display: 'none' });
    $('.t-code').val(e.target.value.replace(/[^\d]/g, ''));
  });

  // $('.validate-code').keyup(function(e) {
  //   $('.validate-code').css({ border: 'none' });
  //   $('#validateCodeError').css({ display: 'none' });
  // });
  // 获取弹框元素
  var modal = $("#trace-code-myModal");
  // 获取关闭弹框的元素
  var closeBtn = $("#trace-code-closeModalBtn");

  // 点击关闭按钮关闭弹框
  closeBtn.on("click", function () {
    modal.css("display", "none");
  });
  // // 在点击弹框外部区域时关闭弹框
  // $(window).on("click", function(event){
  //     if (event.target == modal[0]) {
  //         modal.css("display", "none");
  //     }
  // });

  // 验证按钮点击事件
  var imgCodeToken = '';
  var verifyBtn = $("#trace-code-verifyBtn");
  verifyBtn.on("click", function () {
    var captchaInput = $("#trace-code-captchaInput").val();
    var errrorMsg = $('#errror-msg-mod');
    var errrorMsgInfo = $('#Errror-msg-info');

    if (captchaInput) {
      var code = $('.t-code').val();

      requestForMTOP({ code: captchaInput, token: imgCodeToken }, {
        api: 'mtop.alijk.code.search.checkCode'
      }).then(function (data) {
        if (data.data.result === 'true') {
          errrorMsgInfo.html('');
          errrorMsg.css("opacity", "0");
          //药品的查询
          if (/^[8]/g.test(code)) {
            requestForMTOP({ code: code }, {
              api: 'mtop.alijk.code.search.getshowurl'
            }).then(function (data) {
              if (data.ret[0] == 'SUCCESS::调用成功') {
                var token = data.data.result.split('token=')[1];
                window.location.href = '/drugQueryResult?code=' + code + '&token=' + token + '&imageToken=' + imgCodeToken + '&imageCode=' + captchaInput;
              }
            })["catch"](function (err) {
              alert('查询失败');
            });
          } else if (/^[0,1,2,3,4]/g.test(code)) {
            //非药的查询
            window.location.href = '/rqQueryResult?code=' + code;
          } else {
            alert('暂时不支持药监或质监以外的查询');
          }
        } else {
          errrorMsgInfo.html('验证码填写错误');
          errrorMsg.css("opacity", "1");
          getImgUrl();
        }
      })["catch"](function (err) {
        alert('查询失败');
      });
    } else {
      errrorMsgInfo.html('请输入验证码');
      errrorMsg.css("opacity", "1");
    }
  });
  function getImgUrl() {
    requestForMTOP({ "serviceName": "verificationImageService" }, {
      api: 'mtop.alihealth.drug.ent.service'
    }).then(function (data) {
      var src = data.data ? 'data:image/png;base64,' + data.data.image : '';
      $('#captchaImg').attr("src", data && src);
      imgCodeToken = data.data.token;
      console.log(data, 'dddddd');
    })["catch"](function (err) {
      console.log('查询验证码失败');
    });
  }
  $('#captchaImg').on('click', getImgUrl);
  $('.code-btn').on('click', function (e) {

    var code = $('.t-code').val();
    // var checkCode = $('.validate-code').val();
    if (code == '') {
      $('#scanCode').css({ border: '1px solid red' });
      $('#scanCodeError').css({ display: 'block' }).html('请输入追溯码');
      return;
    }
    if (code.length == 20) {
      $("#trace-code-captchaInput").val('');
      getImgUrl();
      modal.css("display", "block");
      var errrorMsgInfo = $('#Errror-msg-info');
      var errrorMsg = $('#errror-msg-mod');
      errrorMsgInfo.html('');
      errrorMsg.css("opacity", "0");
    } else {
      $('#scanCode').css({ border: '1px solid red' });
      $('#scanCodeError').css({ display: 'block' }).html('位数输入错误');
    }
  });
}

code();

function top() {
  var box = $('.p-top'),
      btn = box.find('button');

  $(window).scroll(function () {
    var height = $(window).height(),
        scrollTop = $(window).scrollTop();
    if (scrollTop > height + 50) {
      box.fadeIn();
    } else {
      box.fadeOut();
    }
  });

  btn.on('click', function () {
    $(window).scrollTop(0);
    //		$("body").animate({scrollTop:"0px"}, 600);
    box.fadeOut();
  });
}

top();
$('.business-btn').on('click', function () {
  $('.drug-box').show();
});
$('.drug-box').on('mouseleave click', function () {
  $('.drug-box').hide();
});


/*****************
 ** WEBPACK FOOTER
 ** ./pages/home/js/home.js
 ** module id = 0
 ** module chunks = 6
 **/